module.exports = __webpack_public_path__ + "img/img7.f3e62f7b.svg";